import { render, staticRenderFns } from "./CookieAlert.vue?vue&type=template&id=67bfad68"
import script from "./CookieAlert.vue?vue&type=script&lang=js"
export * from "./CookieAlert.vue?vue&type=script&lang=js"
import style0 from "./CookieAlert.vue?vue&type=style&index=0&id=67bfad68&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports